import layoutStyle from "../layout-style"
import { getMarginString, getPaddingString, toRGBA, getFontFamily } from "../utils";
import formBasicScript, { getFormConf } from "../form-basic-script";
import rowHtml from "../../Row/row-html";
import closeButtonHtml from "../../CloseButton/close-button-html";
import countdownBasicScript from "../../Countdown/countdown-basic-script";

export default (tree, preview = false) => {

  const {
    defultFont,
    contentAreaVerticleAlignment,
    backgroundColor,
    shadowBlur,
    shadowColor,
  } = tree.root.data;
  const rootPaddingStr = getPaddingString(tree.root.data);
  const rootMarginStr = getMarginString(tree.root.data);

  const closeButton = tree.root.extraComponents.closeButton;

  let contentWidth =
      tree.root.data.contentAreaWidthMode === "percentage"
        ? `${tree.root.data.contentAreaWidthPercentage || 100}%`
        : `${tree.root.data.contentAreaWidth}px`;

  const formConf = getFormConf(tree);
  const fontFamily = getFontFamily(defultFont);

  const containerTag = formConf.hasFormComponents ? "form" : "div";

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        ${layoutStyle}
        ${
          formConf.libsConfig.ripPhoneLib
            ? `<script src="https://riplus-hk.rimanggis.com/file/rip-mm-vendors/libphonenumber-js-1.11.16.min.js"></script>`
            : ""
        }
        ${
          formConf.libsConfig.ripTermsLib
            ? `<script src="https://riplus-hk.rimanggis.com/file/rip-mm-vendors/jquery.popupoverlay.2.1.5.min.js"></script>`
            : ""
        }
        ${formConf.libsConfig.countdownLib ? countdownBasicScript : ""}
        ${formBasicScript(formConf)}
      </head>
      <body>
        <${containerTag}
          id="rip-mm-container"
          class="rip-mm-container"
          style="
            font-family:${fontFamily};
            font-size: 14px;
            width: 100%;
            min-height:100%;
            display:flex;
            flex-direction: column;
            justify-content: ${contentAreaVerticleAlignment};
            background-color: ${toRGBA(backgroundColor)};
            position: relative;
            max-width: ${contentWidth};
          "
        >
          ${closeButtonHtml({ data: closeButton.data })}
          <div style="${rootPaddingStr}${rootMarginStr}box-shadow: 0 0 ${shadowBlur}px ${toRGBA(shadowColor)};">
            ${tree.root.children.map((node) => rowHtml(node, tree, contentWidth, preview)).join("")}
          </div>
        </${containerTag}>
      </body>
    </html>
  `
}
